<!-- 查看内容 -->
<template>
  <div class="el-SeePractice">
    <el-row class="content_block">
      <TitleInfo title="查看内容" :titleImg="zjie"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <!-- <el-row style="margin-bottom: 20px;">
          <label>班级：</label>
          <el-select clearable v-model="search.bj" placeholder="请选择班级">
            <el-option label="天择一班" value="1"></el-option>
            <el-option label="天择二班" value="2"></el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
        </el-row> -->
        <el-row>
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
            <el-table-column prop="handsOnName" header-align="center" align="center" label="项目名称"> </el-table-column>
            <el-table-column prop="typeNum" header-align="center" align="center" label="实操步骤"> </el-table-column>
            <el-table-column prop="type" header-align="center" align="center" label="涵盖的实操类型">
              <template  slot-scope="scope">
               <!-- 观看视频、观看PPT、理论测评、实训操作、报告撰写 -->
                <el-tag v-if="scope.row.isVideo">观看视频</el-tag>
                <el-tag v-if="scope.row.isPpt">观看PPT</el-tag>
                <el-tag v-if="scope.row.isTheory">理论测评</el-tag>
                <el-tag v-if="scope.row.isStep">实训操作</el-tag>
                <el-tag v-if="scope.row.isRreport">报告撰写</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="cz_" header-align="center" align="center" label="操作" width="160">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click="seePracticeDetails(scope.row)">查看</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              background
              :hide-on-single-page="true"
              layout="sizes, prev, pager, next,jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
export default {
  name: "SeePractice",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      zjie:require("../../images/course/zjie@2x.png"),
      search:{
        bj:"",
        input:""
      },
      tableData:[],

      total: 0,
      limit:10,
      page:1,
      handsOnId:this.$route.query.id, //实训ID
      teacherOpenCourseId:this.$route.query.courseId //课程ID
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取通知公告列表
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.teacherOpenCourseId,
        handsOnId:this.handsOnId,
      }
      // param = Object.assign(param,this.search);
      this.$get("/jlw/teacherOpenCourseHandsOn/getTaskTypeParam.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    exportInfo(){ //导出信息
      this.$confirm('是否确定导出信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({type: 'success',message: '导出成功！'});
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    seePracticeDetails(item){ //查看实操详情
      this.$router.push({name:'SeePracticeDetails',query:{courseId:this.teacherOpenCourseId,handsOnId:item.handsOnId}});
    }
  }
};
</script>
 <style  lang="less">
  .el-SeePractice{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/SeePractice.vue